import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiRoutes } from 'consts';
import { apiErrorHandler } from 'services/apiErrorHandler';
import { showErrorNotification } from 'utils/notification';
import { ThunkConfig } from 'app/providers/StoreProvider';

export const getCustomerSuggestions = createAsyncThunk<
  any,
  string,
  ThunkConfig<string>
>('stock/getCustomerSuggestions', async (phone, thunkApi) => {
  const {
    extra: { api },
  } = thunkApi;
  try {
    const { data } = await api.get(ApiRoutes.ClientSuggestions, {
      params: {
        phone,
      },
    });

    return data;
  } catch (error) {
    const { message } = apiErrorHandler(error);
    showErrorNotification([message]);
    // Важно возвращать явно undefined, если функция должна завершиться после ошибки
    return undefined;
  }
});
